import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Button,
  Input,
  Modal,
  Text,
  Icon,
} from '@fairfashion/design-system'
import { useForm, useFieldArray, Controller } from 'react-hook-form'

import { FeedbackAlertContext } from '../../../../components/FeedbackAlert'
import { IconInput } from '../../../../components/IconInput'
import { QRCodeDetailsContext } from '../../qrcode-details.context'

import {
  QRCodeDetailsMetricsForm,
  QRCodeDetailsMetricsFormModalProps,
} from './qrcode-details-metrics-form-modal.types'

export const QRCodeDetailsMetricsFormModal = ({
  open,
  onClose,
}: QRCodeDetailsMetricsFormModalProps) => {
  const [saving, setSaving] = useState(false)

  const { feedbackAlert } = useContext(FeedbackAlertContext)
  const { qrcode, actions } = useContext(QRCodeDetailsContext)

  const { register, reset, handleSubmit, control } =
    useForm<QRCodeDetailsMetricsForm>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'metrics',
  })

  useEffect(() => {
    if (open) {
      if (qrcode?.finishedItemProfile?.metrics?.length) {
        reset({
          metrics: qrcode.finishedItemProfile.metrics,
        })
        return
      }
    }
    reset({
      metrics: [
        {
          icon: 'graph',
          title: '',
          description: '',
        },
      ],
    })
  }, [open, qrcode?.finishedItemProfile?.metrics])

  const onSubmit = async (data: QRCodeDetailsMetricsForm) => {
    setSaving(true)

    await actions.saveFinishedItemProfileMetrics(data)

    setSaving(false)
    onClose()
    feedbackAlert('Métricas salvas com sucesso', 'success')
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Métricas"
      width="800px"
      maxWidth="90%"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box width="100%" direction="column" gap={3}>
          {fields.map((field, index) => (
            <Box
              border={{ width: 1, color: 'grey_4' }}
              borderRadius="16px"
              key={field.id}
              width="100%"
              padding={3}
            >
              <Box width="100%" direction="column" gap={3}>
                <Box
                  width="100%"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text color="grey_3" size="small">
                    Métrica {index + 1}
                  </Text>
                  <Button
                    variant="text"
                    onClick={() => remove(index)}
                    padding="0"
                  >
                    <Icon name="delete_bin" size={20} color="error" />
                  </Button>
                </Box>

                <Box gap={2} width="100%">
                  <Box width="70px">
                    <Controller
                      control={control}
                      name={`metrics.${index}.icon`}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <IconInput
                          label="Ícone"
                          value={field.value}
                          onChange={field.onChange}
                          required
                        />
                      )}
                    />
                  </Box>
                  <Box flex={1}>
                    <Input
                      label="Título"
                      {...register(`metrics.${index}.title`)}
                      required
                    />
                  </Box>
                </Box>

                <Box width="100%">
                  <Input
                    label="Descrição"
                    {...register(`metrics.${index}.description`)}
                    required
                  />
                </Box>
              </Box>
            </Box>
          ))}

          <Box width="100%" justifyContent="center">
            <Button
              onClick={() =>
                append({ icon: 'graph', title: '', description: '' })
              }
              padding="10px 16px"
            >
              <Box gap={1} alignItems="center">
                <Icon name="add" size={20} />
                <Text size="small" fontWeight={500}>
                  Adicionar Métrica
                </Text>
              </Box>
            </Button>
          </Box>

          <Box width="100%" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={onClose} padding="10px 16px">
              <Text size="small" fontWeight={500}>
                Cancelar
              </Text>
            </Button>
            <Button padding="10px 16px" type="submit" loading={saving}>
              <Text size="small" fontWeight={500} color="white">
                Salvar
              </Text>
            </Button>
          </Box>
        </Box>
      </form>
    </Modal>
  )
}
